var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMetroApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.098,
    height: 13.628,
    viewBox: "0 0 11.098 13.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-apple",
    "data-name": "Icon metro-apple",
    d: "M9.266,7.241a3.083,3.083,0,0,1,1.47-2.6A3.183,3.183,0,0,0,8.244,3.3c-1.06-.108-2.071.625-2.609.625s-1.368-.609-2.249-.593A3.334,3.334,0,0,0,.567,5.036c-1.2,2.086-.305,5.174.866,6.866C2,12.73,2.687,13.66,3.584,13.627c.863-.034,1.189-.558,2.233-.558s1.337.558,2.25.541c.929-.017,1.517-.844,2.085-1.674A7.514,7.514,0,0,0,11.1,10,3.01,3.01,0,0,1,9.267,7.241ZM7.55,2.176A3,3,0,0,0,8.259,0,3.054,3.054,0,0,0,6.253,1.032,2.858,2.858,0,0,0,5.529,3.14,2.527,2.527,0,0,0,7.55,2.176Z",
    transform: "translate(0.002)",
    fill: "#f49a56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetroApple);
export default __webpack_public_path__ + "static/media/icon-metro-apple.1b99d830692885502dda918322e2f7cc.svg";
export { ForwardRef as ReactComponent };